import { render } from "./spinner.vue?vue&type=template&id=36ef40bd&scoped=true"
import script from "./spinner.vue?vue&type=script&lang=js"
export * from "./spinner.vue?vue&type=script&lang=js"

import "./spinner.vue?vue&type=style&index=0&id=36ef40bd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ef40bd"]])

export default __exports__